import PropTypes from "prop-types";
import React from "react";
import { Button, ButtonSize } from "shared/Button";
import SpinningIcon from "shared/SpinningIcon";
import styles from "./SpeakerListItem.module.css";

function SpeakerListItem({
  id,
  photo,
  name,
  onEdit,
  onSelect,
  isSelectionMode,
  isSelected,
  isLoading,
  disabled,
  isNewlySaved,
}) {
  const handleEdit = () => {
    if (!disabled) {
      onEdit(id);
    }
  };

  const handleSelect = () => {
    onSelect(id);
  };

  return (
    <article
      className={`${styles.row} ${
        isNewlySaved ? styles.newlySaved : ""
      }`.trim()}
      aria-label={`Speaker item ${name}`}
    >
      {photo ? (
        <img className={styles.photo} src={photo} alt={name} />
      ) : (
        <div className={styles.photoEmpty} aria-label="No speaker image">
          No Image
        </div>
      )}

      <div className={styles.meta}>
        <div className={styles.nameContainer}>
          <p className={styles.name}>{name}</p>
          {isNewlySaved && (
            <span className={styles.savedBadge} aria-label="Recently saved">
              ✓ Saved
            </span>
          )}
        </div>
      </div>

      <div className={styles.actions}>
        {isSelectionMode ? (
          <div className={styles.selectionControls}>
            <Button
              size={ButtonSize.small}
              className={styles.selectButton}
              onClick={handleEdit}
              aria-label={`Edit ${name}`}
            >
              {isLoading ? <SpinningIcon size={16} /> : "Edit"}
            </Button>

            <button
              type="button"
              className={`${styles.selectIndicator} ${
                isSelected ? styles.selectIndicatorChecked : ""
              }`}
              onClick={handleSelect}
              aria-label={`${isSelected ? "Unselect" : "Select"} ${name}`}
            >
              <span
                className={styles.selectIndicatorCheck}
                aria-hidden="true"
              />
            </button>
          </div>
        ) : (
          <Button
            size={ButtonSize.small}
            className={styles.editButton}
            onClick={handleEdit}
            aria-label={`Edit ${name}`}
          >
            {isLoading ? <SpinningIcon size={16} /> : "Edit"}
          </Button>
        )}
      </div>
    </article>
  );
}

SpeakerListItem.propTypes = {
  id: PropTypes.string.isRequired,
  photo: PropTypes.string,
  name: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func,
  isSelectionMode: PropTypes.bool,
  isSelected: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  isNewlySaved: PropTypes.bool,
};

SpeakerListItem.defaultProps = {
  photo: "",
  onEdit: () => {},
  onSelect: () => {},
  isSelectionMode: false,
  isSelected: false,
  isLoading: false,
  disabled: false,
  isNewlySaved: false,
};

export default SpeakerListItem;
